let trackingEvent = require('./Events/TrackingEvent');

module.exports = (flex = window.flex, FlexApiRequest = window.FlexApiRequest) => {

    const TrackingEvent = trackingEvent(flex, FlexApiRequest);

    function registerModule(initializer) {
        if (typeof (initializer) !== 'function') {
            console.warn('Attempting to register a tracking module with an invalid initializer.  Initializer must be a function');
            return;
        }

        const ACTION_NAMES = initializer(TrackingEvent);

        let { getStore, setStore } = flex,
            { tracking = { actionNames: [] } } = getStore(),
            actionNameKeys = Object.keys(ACTION_NAMES),
            actionNameCollection = actionNameKeys.map(key => ACTION_NAMES[key]);

        let actionNames = tracking.actionNames.concat(actionNameCollection);

        setStore({ tracking: { actionNames } });
    }

    return registerModule;
};